import { useQuery } from '@tanstack/react-query';
import { Card } from '@atoms/Card';
import { Spinner } from '@atoms/Spinner';
import { Badge } from '@atoms/Badge';
import { reviewService } from '@services/reviewService';
import { formatShortDate } from '@utils/formatters';

export function ReviewsSection() {
  const { data: reviews, isLoading } = useQuery({
    queryKey: ['wholesaler', 'reviews'],
    queryFn: () => reviewService.getWholesalerReviews(),
  });

  if (isLoading) return <Spinner />;

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Değerlendirmeler</h1>
        <p className="mt-1 text-sm text-slate-500">Restoran geri bildirimleri</p>
      </div>

      {!reviews?.length ? (
        <Card className="text-center text-slate-500">Henüz değerlendirme yok</Card>
      ) : (
        reviews.map((r) => (
          <Card key={r.id} className="card-elevated">
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="font-medium text-slate-900">{r.restaurantName ?? 'Restoran'}</p>
                <p className="text-xs text-slate-500">{formatShortDate(r.createdAt)} · Sipariş #{r.orderId.slice(0, 8)}</p>
              </div>
              <Badge variant="success">{(r.avgRating ?? 0).toFixed(1)} / 5</Badge>
            </div>
            <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs">
              <div className="rounded-lg bg-slate-50 p-2"><p className="text-slate-500">Hız</p><p className="font-semibold">{r.ratingSpeed}</p></div>
              <div className="rounded-lg bg-slate-50 p-2"><p className="text-slate-500">Kalite</p><p className="font-semibold">{r.ratingQuality}</p></div>
              <div className="rounded-lg bg-slate-50 p-2"><p className="text-slate-500">Lezzet</p><p className="font-semibold">{r.ratingFlavor}</p></div>
            </div>
            {r.comment && <p className="mt-3 text-sm text-slate-600">{r.comment}</p>}
          </Card>
        ))
      )}
    </div>
  );
}
